export const UNAUTHORIZED = 'unauthorized'
export const CONSULTANT = 'consultant'
export const CUSTOMER = 'customer'
export const ADMIN = 'admin'



// WEBPACK FOOTER //
// ./src/userTypes.js